export const OWNER_TYPE = {
  organization: 'organization',
  account: 'account',
};
